import { FRAME_TYPE_MAP } from '@/pages/benchmark/_config/constant';
import { BaseComponentProps } from '@/pages/benchmark/types/commom';
import {
  formatFilterValues,
  getDownValueType,
  getMetricFormatRule,
  nameWidth,
} from '@/pages/benchmark/utils/utils';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { getLocale, useParams } from 'umi';
import MetricDetailTableSearchBox from '../MetricDetailTableSearchBox';

export interface IMetricDetailTableServiceProps extends BaseComponentProps {
  [key: string]: any;
}

const MetricDetailTableService = (props: IMetricDetailTableServiceProps) => {
  const {
    style,
    className,
    children,
    data,
    filterVal,
    filterLoading,
    selectorList,
    percentileTip = {},
    searchConfig,
    ...resetProps
  } = props;
  const isEn = getLocale() === LANGUAGE_EN;
  const { metric } = useParams<{ metric: string; }>();
  const [newFilterValue, setNewFilterValue] = useState<any>(null);
  const [selectedValue, setSelectedValue] = useState('255');
  const metricMap = data.metricConfig || {};

  const {
    tooltipEn,
    tooltipCn,
    formatter,
    nameEn = '',
    nameCn = '',
    scalar_type,
  } = metricMap[metric] || {};

  const metricColumnList = [
    {
      metricKey: metric,
      reqMetricKey: metric,
      enName: nameEn,
      cnName: nameCn,
      enWidth: nameWidth(nameEn, true),
      cnWidth: nameWidth(nameCn, false),
      type: getDownValueType(formatter, scalar_type),
      formatter: getMetricFormatRule({ formatter, scalar_type }),
      tooltipEn,
      tooltipCn,
    },
    // 百分位非指标，需要单独配置
    {
      metricKey: `${metric}_percentile`,
      reqMetricKey: `${metric}_percentile`,
      enName: 'Percentile',
      cnName: '百分位',
      enWidth: 100,
      cnWidth: 100,
      type: "percent",
      formatter: 'percent2Decimal',
      tooltipEn: percentileTip?.tooltipEn,
      tooltipCn: percentileTip?.tooltipCn,
    },
  ];

  useEffect(() => {
    if (filterLoading) return;
    // 筛选器变化请求重置宽表filter状态
    setSelectedValue('255');
    setNewFilterValue({
      filters: { ...formatFilterValues(filterVal)},
      metrics: [metric],
      frame_type: FRAME_TYPE_MAP[data?.frameType],
    });
  }, [filterLoading, filterVal]);

  const filterOptions = useMemo(() => {
    const genre = filterVal?.genre_subgenre?.genre;
    const { genre_subgenre_list: genreGameList = [] } = selectorList || {};
    const optionsAllList: any = { value: "255", text: getLanguage(isEn, 'All', '全部') };
    const selectedGenre = genreGameList?.filter((item: { code: any; })=>genre?.includes(item.code)) || [];
    const selectedGenreList = selectedGenre?.map((item:any)=>({
      text: getLanguage(isEn, item?.name_en, item?.name_ch),
      value: item.code
    }))|| [];
    return [optionsAllList, ...selectedGenreList];
  }, [filterVal, isEn, selectorList]);

  // Genre下拉漏斗
  const handleFilterChange = (value: string) => {
    setSelectedValue(value);
    setNewFilterValue({
      filters: { ...formatFilterValues(filterVal), genre_list: [value]},
      metrics: [metric],
      frame_type: FRAME_TYPE_MAP[data?.frameType],
    });
  };

  // 宽表过滤器设置
  const filterConfig = useMemo(() => ({
    type: 'single',
    column: 'genre',
    value: selectedValue,
    onChange: (value: string) => {
      if (selectedValue === value) return;
      handleFilterChange(value);
    },
    options: filterOptions,
  }), [filterOptions, selectedValue]);

  if (selectorList?.game_list?.length > 0) {
    // 表格搜索栏
    let beforeTableSolt = null;
    if (searchConfig) {
      beforeTableSolt = <MetricDetailTableSearchBox {...searchConfig} filter={newFilterValue} type={getDownValueType(formatter, scalar_type)} />;
    }

    return (
      <div style={style} className={classNames(className)}>
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...resetProps,
            filterLoading,
            filterVal: newFilterValue,
            metricColumnList,
            filterConfig,
            selectedValue,
            beforeTableSolt
          }),
        )}
      </div>
    );
  }
  return null;
};
export default MetricDetailTableService;
